import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export function HomeIcon(props: SvgIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 14 14" {...props}>
      <path d="M2 6H0V14H2V6Z" fill="currentColor" />
      <path d="M4 0H6V14H4V0Z" fill="currentColor" />
      <path d="M8 5H10V14H8V5Z" fill="currentColor" />
      <path d="M12 3H14V14H12V3Z" fill="currentColor" />
    </SvgIcon>
  );
}
